export const companyHomeKeys = {
    all: ['company-home'] as const,
    directoryUsers: () => [...companyHomeKeys.all, 'directory-users'] as const,
    journey: (positions: boolean, skip: readonly string[]) =>
        [...companyHomeKeys.journeys(), positions, ...skip] as const,
    journeys: () => [...companyHomeKeys.all, 'journey'] as const,
    learningStatistics: () => [...companyHomeKeys.all, 'learning-statistics'] as const,
} as const;
